module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h5>'+
((__t=( i18n.tc( "PhoneNumbers", "Phone numbers for %s" ).format( email) ))==null?'':__t)+
'</h5><div data-region="phone-container"></div><fieldset class="button-wrap text-left"><small><a href="#" data-click="phone-create">'+
((__t=( i18n.tc("PhoneNumbers", "Add new phone number?") ))==null?'':__t)+
'</a></small></fieldset><fieldset class="button-wrap"><button data-click="phone-cancel">'+
((__t=( i18n.tc("PhoneNumbers", "Cancel") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
